export const APP_NAME = 'Sharpe';

/**
 * Sentinel value used as `iconUrl` for Sharpe's own connectors/documents.
 * NOT a real file path -- frontend checks against this to render the
 * theme-aware <SharpeLogo /> component instead of a plain <img>.
 */
export const SHARPE_ICON_SENTINEL = '__sharpe_icon__';
